import {
  Pagination,
  PaginationItem,
  PaginationProps,
  PaginationItemProps,
} from '@mui/material'
import styled from '@emotion/styled'
import { ReactComponent as ArrowLeftSVG } from 'assets/svg/new-icons/arrowleft.svg'
import { ReactComponent as ArrowRightSVG } from 'assets/svg/new-icons/arrowright.svg'

export const BasePaginationItem = styled((props: PaginationItemProps) => (
  <PaginationItem
    components={{ previous: ArrowLeftSVG, next: ArrowRightSVG }}
    {...props}
  />
))<PaginationItemProps>(({ theme }) => ({
  position: 'relative',
  fontSize: '18px',
  fontWeight: 400,
  minWidth: '12px',
  maxHeight: '18px',
  borderBottom: '5px solid',
  borderColor: 'transparent',
  boxSizing: 'content-box',
  borderRadius: 0,
  '&:hover': {
    backgroundColor: 'transparent',
    '&.Mui-selected': {
      backgroundColor: 'transparent',
    },
  },
  '&.Mui-selected': {
    fontWeight: 900,
    color: 'black',
    backgroundColor: 'transparent',
    '&::after': {
      position: 'absolute',
      bottom: '-5px',
      content: '" "',
      backgroundColor: 'black',
      height: '5px',
      width: '12px',
    },
  },
  '&.MuiButtonBase-root-MuiPaginationItem-root': {
    backgroundColor: 'red',
  },
}))

export const BasePagination = styled((props: PaginationProps) => (
  <Pagination
    siblingCount={2}
    boundaryCount={1}
    shape="rounded"
    renderItem={(item) => <BasePaginationItem {...item} />}
    {...props}
  />
))<PaginationProps>(({ theme }) => ({
  '& .MuiPagination-ul': {
    gap: '22px',
  },
}))
export default BasePagination
